/**
 * Cria um array flat
 * @param {Array} arr
 */
export function flatten(arr) {
  return arr.reduce(
    (flat, toFlatten) =>
      flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten),
    []
  );
}

/**
 * Agrupa array de objetos por alguma key
 * @param {Array} list
 * @param {String} props
 */
export function groupBy(list, props) {
  return list.reduce((a, b) => {
    (a[b[props]] = a[b[props]] || []).push(b);
    return a;
  }, {});
}

/**
 * Pega o último valor de um array
 * @param {Array} list
 */
export function getLastValueFromList(list) {
  return list[list.length - 1];
}

/**
 * Verifica se o array possui o valor procurado
 * @param {Array} list
 * @param {Sting} param
 * @param {String|Number} value
 */
export function hasValueInList(list, param, value) {
  return list.some(listItem => listItem[param] === value);
}

/**
 * Remove um elemento do array de obejtos com base em uma key
 * @param {Array} list
 * @param {String|Number} key
 * @param {String|Number} value
 */
export function removeItemArrayObject(list, key, value) {
  return list.filter(item => item[key] !== value);
}
